import { defineStore } from 'pinia'
import { ref, shallowRef } from 'vue'

export const useGlobalStore = defineStore('global', () => {
  const isSdkReady = ref(false)
  const isCalling = ref(false)
  const callType = ref('') // 'video' | 'audio'
  const timInstance = shallowRef(null)
  const trtcInstance = shallowRef(null)
  
  // 用户在线/通话状态 map: { userId: 'online' | 'calling' | 'offline' }
  const userStatusMap = ref({})

  // Toast 通知
  const toastMsg = ref('')
  const toastTimer = ref(null)

  function showToast(msg, duration = 2500) {
    toastMsg.value = msg
    if (toastTimer.value) clearTimeout(toastTimer.value)
    toastTimer.value = setTimeout(() => {
      toastMsg.value = ''
    }, duration)
  }

  function setTimInstance(tim) {
    timInstance.value = tim
  }

  function setTrtcInstance(trtc) {
    trtcInstance.value = trtc
  }

  function setSdkReady(val) {
    isSdkReady.value = val
  }

  function setUserStatus(userId, status) {
    userStatusMap.value[userId] = status
  }

  function startCall(type) {
    isCalling.value = true
    callType.value = type
  }

  function endCall() {
    isCalling.value = false
    callType.value = ''
  }

  return {
    isSdkReady,
    isCalling,
    callType,
    timInstance,
    trtcInstance,
    userStatusMap,
    toastMsg,
    setTimInstance,
    setTrtcInstance,
    setSdkReady,
    setUserStatus,
    startCall,
    endCall,
    showToast
  }
})
